// useForm.js
import { useState } from 'react';
import { _setAxios, _success } from 'lib/Helper';

const useSendNotif = (data, fetchTable, hideModal) => {
    const [loading, setLoading] = useState(false);

    const handleSubmit = () => {
        setLoading(true);

        let endpoint = "kaldik-kegiatan/pramuka/siswa/send-wa-ketidakhadiran";
        let method = "POST";

        _setAxios(endpoint, method, {
            siswa_id: data?.siswa_id,
            tgl: data?.tgl
        }).then(resp => {
            if (resp.status) {
                _success('topRight', 'Success', resp.data.message)
                fetchTable(true);
                hideModal();
            }
            setLoading(false);
        }).catch(err => {
            setLoading(false);
        });
    };

    return {
        loading,
        handleSubmit,
    };
};

export default useSendNotif;
